<input
  type="radio"
  [attr.aria-labelledby]="inputId() + 'radio-label'"
  test-id="ms-radio-input"
  class="btn-check"
  [name]="name()"
  [attr.id]="inputId()"
  [checked]="selected()"
  [disabled]="isDisabled()"
  [readOnly]="readOnly()"
  [value]="value()"
  (click)="click($event)"
  (blur)="blur()"
  (focusin)="focusin($event)"
/>

@let innerHtml = innerHtmlContent();
@if (innerHtml) {
  <label
    [id]="inputId() + 'radio-label'"
    [attr.tabindex]="0"
    class="btn btn-outline-primary"
    [attr.for]="inputId()"
    [innerHTML]="innerHtml">
  </label>
} @else {
  <label
    [id]="inputId() + 'radio-label'"
    [attr.tabindex]="0"
    class="btn btn-outline-primary"
    [attr.for]="inputId()">
    <ng-content></ng-content>
  </label>
}
